<template>
  <v-row dense>
    <v-col
        cols="12"
        sm="4"
        v-for="item in items"
        :key="item.id"
    >
      <v-list-item
          class="border"
          style="text-decoration: none;"
          @click="$emit('close'); $router.push('/income/sales/'+item.id)"
          :to="'/income/sales/'+item.id"
      >
        <v-list-item-content>
          <v-list-item-title
              class="font-weight-black green--text"
          >
            {{item.amount_due | toMoney | currency_symbol}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Number:{{item.sales_number}}
          </v-list-item-subtitle>

          <v-list-item-subtitle>
            Date:{{item.entry_date}}
          </v-list-item-subtitle>

          <v-list-item-subtitle v-if="item.server">
            By:{{item.server}}
          </v-list-item-subtitle>


        </v-list-item-content>
      </v-list-item>

    </v-col>
    <v-col cols="12" sm="4">
      <v-card outlined tile>
        <v-card-text>
          <v-btn
              large
              text
              rounded
              color="green"
              to="/income/sales"
              block
              @click="$emit('close'); $router.push('/income/sales')"
          >Go to Accounts <v-icon>mdi-arrow-right</v-icon></v-btn>

        </v-card-text>
      </v-card>
    </v-col>

  </v-row>

</template>

<script>
export default {
  props:['items'],
  name: "SearchSales"
}
</script>

<style scoped>

</style>